module.exports = __webpack_public_path__ + "img/slide2-2.28663fae.png";